export default "__VITE_ASSET__KHQ_PMbm__"